import LoginForm from "./LoginForm";
import RegistraionForm from "./RegistraionForm";
import ResetPassword from "./ResetPassword";
import React, {useContext} from "react";
import {AuthContext} from "../context/LoginContext";
import {useLanguage} from "../context/LanguageContext";

const LoginFormWrapper = () => {
    const {t} = useLanguage();
    const loginContext = useContext(AuthContext);
    const [resetPasswordActive, setResetPasswordActive] = React.useState(false);
    const [loginActive, setLoginActive] = React.useState(true);
    const [registerActive, setRegisterActive] = React.useState(false);

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setRegisterActive(false);
        setLoginActive(false);
        setResetPasswordActive(true);
    }
    const handleRegister = (e) => {
        e.preventDefault();
        setResetPasswordActive(false);
        setLoginActive(false);
        setRegisterActive(true);
    }

    const handleLogin = (e) => {
        e.preventDefault();
        setResetPasswordActive(false);
        setRegisterActive(false);
        setLoginActive(true);
    }

    const handleRegisterSuccess = () => {
        setRegisterActive(false);
        setResetPasswordActive(false);
        setLoginActive(true);
    };

    const getHeadingTitle = () => {
        if (registerActive) return t('auth.registerTitle');
        if (resetPasswordActive) return t('auth.resetPasswordTitle');
        return t('auth.loginTitle');
    };

    return (
        <div>
            {!loginContext.isLoggedIn &&
                <div className="heading heading--center">
                    <div className="heading__line" aria-hidden="true"></div>
                    <h2 className="heading__title">{getHeadingTitle()}</h2>
                </div>
            }
            {registerActive ? <RegistraionForm onRegisterSuccess={handleRegisterSuccess}/> : null}
            {loginActive ? <LoginForm/> : null}
            {resetPasswordActive ? <ResetPassword/> : null}
            <div className="row justify-content-center">
                <div className="mt-3"></div>
                {
                    !loginContext.isLoggedIn ?
                        <button
                            className="m-1 btn--link"
                            onClick={handleRegister}
                            aria-label={t('auth.register')}
                            type="button"
                        >
                            {t('auth.register')}
                        </button>
                        : null
                }
                {
                    !loginContext.isLoggedIn ?
                        <button
                            className="m-1 btn--link"
                            onClick={handleResetPassword}
                            aria-label={t('auth.forgotPassword')}
                            type="button"
                        >
                            {t('auth.forgotPassword')}
                        </button>
                        : null
                }
                {
                    !loginContext.isLoggedIn ?
                        <button
                            className="m-1 btn--link"
                            onClick={handleLogin}
                            aria-label={t('auth.loginLink')}
                            type="button"
                        >
                            {t('auth.loginLink')}
                        </button>
                        : null
                }
                <div className="mt-3"></div>
            </div>
        </div>
    )

}

export default LoginFormWrapper;
